/*
 * @fileOverView TimelineAnchorLink component definition
 */

import Vue from 'vue';

Vue.component('timeline-anchor-links-vue', {
  props: {
    activeYear: String,
    filteredYears: Array
  }
})
